import React from "react";
import Tabs from '../Tabs/Tabs';
import ModalButtons from "../ModalButtons/ModalButtons";
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer, CardElement } from '@stripe/react-stripe-js';
import { format, parseISO } from 'date-fns';
import DateHelper from "../DateHelper/DateHelper";
import CreditCardForm from "../BookingFlow/CreditCardForm";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

export default class UpdateReservationCC extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      loading: true,
      activeTab: 'general',
      stripe: null, 
      cardId: null,
      addNewCardVisible: false, 
      newCard: { save_card: true},
      errors: null, 
    };
  };

  async componentDidMount() {
    const stripe = await loadStripe(this.props.public_gateway_key);
    this.setState({ stripe: stripe, loading: false });
  };

  render(){
    return(
      <div className="UpdateReservationCard">
        <Tabs tabs={this.tabs()} />
        <LoadingSpinner show={this.state.loading} />
        <div className="panel panel-form">
          <div className="tab-content">
            {this.renderHeaderErrors()}
            {
              this.state.stripe
              ?
                <Elements
                  stripe={this.state.stripe}
                  options={{
                    locale: navigator.languages && navigator.languages.length
                      ? navigator.languages[0]
                      : navigator.language
                  }}
                >
                  <ElementsConsumer>
                    {({ stripe, elements }) => (
                      [
                        <div key="form-wrapper">
                          {this.renderCards()}
                        </div>,
                        <ModalButtons loading={this.state.loading} buttons={this.setButtons(elements)} key="ModalButtons" />
                      ]
                    )}
                  </ElementsConsumer>
                </Elements>
                :
                null
            }
          </div>
        </div>
      </div>
    );
  };

  renderCards = () => {
    if (!this.state.addNewCardVisible && this.props.customer_cards.length){
      var cards = this.props.customer_cards.map((card) => {

        return (
          <div className={"card " + (this.state.cardId == card.id ? 'card-selected' : '')} key={card.id}>
            <label className="customer-cards-label" >
              <input onChange={this.onChange} type="radio" name="cardId" value={card.id} checked={this.state.cardId == card.id ? true : false} />
              <span className={"credit-card-icon small " + card.brand}> </span> 
              {I18n.t('ending_in').toLowerCase()} <strong>{card.last_4}</strong> {I18n.t('exp')} <strong>{card.month}/{card.year}</strong> {I18n.t('last_payment')} <strong>{card.last_payment ? format(parseISO(card.last_payment.processed_at), DateHelper.rubyToDateFNS(this.props.date_format) + ' ' + DateHelper.rubyToDateFNS(this.props.time_format)) : I18n.t('none')} </strong>
            </label>
          </div>
        );
      });
    };

    return (
      <div className="row">
        <div className={"col-md PaymentMethod"} >
          {this.props.customer_cards.length ? <span> <a href="#" name="addNewCardVisible" onClick={this.onChange}>{I18n.t(this.state.addNewCardVisible ? 'use_existing_cards' : 'add_new_card')}</a></span> : null}
          {
            (this.state.addNewCardVisible || this.props.customer_cards.length == 0)
              ?
              <CreditCardForm
                card={this.state.newCard}
                onChangeCardInput={this.onChange}
                errors={this.props.errors}
                customer={this.props.customer}
                saveCard={true}
                hasClassErrors={this.hasClassErrors}
                renderFieldErrors={this.renderFieldErrors}
                disableNameOnCard={this.state.disableNameOnCard}
                additionalClasses="container"
                cardInputWidth="col-sm-3"
                nameOnCardInputWidth="col-sm-3"
              />
              :
              <div className="cards">{cards}</div>
          }
        </div>
      </div>
    );

  };

  tabs = () => {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
        }
      ]
    );
  };

  setButtons = (elements) => {
    return(
      [
        {
          name: I18n.t('cancel'),
          html_attributes: [
            'data-dismiss="modal"'
          ],
          onClick: (e) => {
            parent.hide_modal()
          }
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary', 'modal-footer', 'btn-primary', 'submit-buttons, btn-primary'],
          onClick: (e) => {
            this.save(e, elements);
          }
        }
      ]
    );
  };

  renderHeaderErrors = () => {
    if (this.state.errors && this.state.errors.header_errors){
      let errors = this.state.errors.header_errors.map((error, idx) => {
        return <li key={idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

  hasClassErrors = (braketReference) => {
    if (this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[braketReference]) {
      return true;
    } else {
      return false;
    };
  };

  renderFieldErrors = (braketReference) => {
    if (this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[braketReference]) {
      return <div className="help-block"><ul><li><b>&#x2022;</b>{this.state.errors.field_errors[braketReference]}</li></ul></div>
    };
  };

  onChange = (e) => {
    if (e.target.name == "addNewCardVisible") {
      this.setState({ addNewCardVisible: !this.state.addNewCardVisible })
    } else if (e.target.name == "save_card"){
      let card = this.state.newCard
      card.save_card = e.target.checked
      this.setState({newCard: card})
    } else if (e.target.name == 'name_on_card'){
      let card = this.state.newCard
      card.name_on_card = e.target.value
      this.setState({ newCard: card })
    } else {
      this.setState({[e.target.name]: e.target.value});
    };
  };

  save = async  (e, elements) => {
    this.setState({ loading: true });
    e.preventDefault();

    if (!this.state.addNewCardVisible && this.props.customer_cards.length) {
      this.confirmUpdate();
    } else if (this.state.addNewCardVisible || this.props.customer_cards.length == 0) {
      if(this.state.newCard && this.state.newCard.name_on_card){
        
        var stripe = this.state.stripe;
        var cardElement = elements.getElement(CardElement);

        if (!stripe || !elements) {
          console.log('We should never hit this! Either Stripe or Elements is not loaded!')
          return;
        }

        const result = await stripe.createPaymentMethod({
          type: 'card',
          card: cardElement,
          billing_details: {
            name: this.state.newCard.name_on_card,
          },
        });

        this.setState({ disableNameOnCard: true });

        if(result.error) {
          var errors = {
            header_errors: [result.error.message],
            field_errors: { card_validation_error: result.error.message },
          };

          this.setState({ errors: errors, loading: false })
        } else if (result.paymentMethod) {

          this.confirmUpdate(result.paymentMethod)
        } else {
          console.log('should not hit here potential async issue')
        }

      } else{

        let errors = {
          header_errors: [],
          field_errors: {},
        }

        if(!this.state.newCard.name_on_card){
          errors.header_errors.push(I18n.t('name_on_card_error'))
          errors.field_errors.name_on_card_error = I18n.t('name_on_card_error')
        };

        this.setState({ errors: errors, loading: false });
      };
    };
  };

  confirmUpdate = (token=null) => {
    $.ajax({
      type: 'POST',
      url: this.props.update_cc_path,
      data: {
        card_id: this.state.cardId,
        new_card: token,
        save_card: this.state.newCard && this.state.newCard.save_card ? this.state.newCard.save_card : false,
      }
    }).done((data) => {
      if(data.errors && data.errors.header_errors.length) {
        this.setState({ loading: false, errors: data.errors });
      } else {
        parent.reservationUpdated()
        parent.hide_modal()
      }
    });
  };

};